module.exports = "/images/vendor/flag-icon-css/flags/4x3/aw.svg?47ea7038c8fea471afdd906694068310";